import React, {Component} from "react";
import PropTypes from "prop-types";

class Pagination extends Component {

    state = {
        showLeftArrow: false,
        showRightArrow: false,
        numbersToLeft: [],
        numbersToRight: []
    };

    componentDidMount(){

    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps !== this.props){
            this.setArrowsAndNumbers();
        }
    }

    setArrowsAndNumbers = () => {
        const {numberOfPages, currentPage, numberOfButtons} = this.props;

        if(numberOfPages <= numberOfButtons){
            let numbersToLeft = [];
            let numbersToRight = [];
            for(let i = 1; i < currentPage; i++){
                numbersToLeft.push(i);
            }
            for(let i = currentPage + 1; i <= numberOfPages; i++){
                numbersToRight.push(i);
            }
            this.setState({showLeftArrow: false, showRightArrow: false, numbersToLeft, numbersToRight });
        }else{
            this.setLeftSideValues();
            this.setRightSideValues();
        }
    };

    setLeftSideValues = () => {
        const {numberOfPages, currentPage, numberOfButtons} = this.props;
        const pagesAround = Math.floor(numberOfButtons/2);

        let numbersToLeft = [];
        let showLeftArrow = false;

        if(currentPage > pagesAround + 1){
            const iterationsAfterCurrent = numberOfPages - currentPage;
            const stopBefore = iterationsAfterCurrent >= pagesAround ? pagesAround : pagesAround + pagesAround - iterationsAfterCurrent;

            for(let i = currentPage - 1; i >= currentPage - stopBefore; i--){
                numbersToLeft.push(i);
            }
            showLeftArrow = true;
            numbersToLeft.reverse();
        }else{
            const iterations = currentPage - 1;
            for(let i = iterations; i > 0; i--){
                numbersToLeft.push(i);
            }

            numbersToLeft.reverse();
        }
        this.setState({numbersToLeft,showLeftArrow})
    };

    setRightSideValues = () => {
        const {numberOfPages, currentPage, numberOfButtons} = this.props;
        const pagesAround = Math.floor(numberOfButtons/2);
        let numbersToRight = [];
        let showRightArrow = false;

        if(numberOfPages - currentPage >= pagesAround + 1){
            const iterationsBeforeCurrent = currentPage - 1;
            const stopAfter = iterationsBeforeCurrent >= pagesAround ? pagesAround : numberOfButtons - iterationsBeforeCurrent - 1;

            for(let i = currentPage + 1; i <= currentPage + stopAfter; i++){
                numbersToRight.push(i);
            }
            showRightArrow = true;
        }else{
            for(let i = currentPage + 1; i <= numberOfPages; i++){
                numbersToRight.push(i);
            }
        }
        this.setState({numbersToRight,showRightArrow})
    };

    arrowBack = () => {
        const {callback, currentPage} = this.props;
        callback(currentPage - 1);
    };

    arrowForward = () => {
        const {callback, currentPage} = this.props;
            callback(currentPage + 1);
    };

    setPage = (page) => {
        const {callback} = this.props;
        callback(page);
    };

    isOdd = (num) => {
        return num % 2;
    };

    render() {
        const {currentPage, numberOfButtons, numberOfPages} = this.props;
        const {showLeftArrow, showRightArrow, numbersToRight, numbersToLeft} = this.state;
        if(this.isOdd(numberOfButtons)){
            if(!!numberOfPages){
                return (
                    <div className={"pagination-container pagination-module"}>
                        <ul className={"pagination"}>
                            {showLeftArrow && <li className={"PagedList-skipToPrevious"}><a onClick={() => this.arrowBack()} rel="prev">&#61700;&#61700;</a></li>}

                            {numbersToLeft.map((number) => {
                                return <li><a onClick={() => this.setPage(number)}>{number}</a></li>;
                            })}

                            <li className="active"><a>{currentPage}</a></li>

                            {numbersToRight.map((number) => {
                                return <li><a onClick={() => this.setPage(number)}>{number}</a></li>;
                            })}

                            {showRightArrow && <li className="PagedList-skipToNext"><a onClick={() => this.arrowForward()} rel="next">&#61701;&#61701;</a></li>}
                        </ul>
                    </div>
                )
            }else{
                return null;
            }

        }else{
            {console.error("numberOfButtons must be odd, you provided: ", numberOfButtons)}
            return null;
        }

    }
}
Pagination.propTypes = {
    numberOfPages: PropTypes.number,
    currentPage: PropTypes.number,
    callback: PropTypes.function,
    numberOfButtons: PropTypes.number
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/js/components/Pagination.js